import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Spinners from "components/Common/Spinner";

// Import i18n
import { withTranslation } from "react-i18next";

// Import service
import { totalSoal } from "../../services/soalService";
import { totalUser } from "../../services/userService";

// --- Pastikan path ini sesuai dengan lokasi ImageSlider.js Anda ---
import ImageSlider from "./ImageSlider";

// --- Komponen Card Mini-Stats (Tidak Berubah) ---
const LiveStreamingCard = () => (
  <Card className="mini-stats-wid shadow-sm border-0" style={{ borderRadius: '12px' }}>
    <CardBody>
      <div className="d-flex">
        <div className="flex-grow-1">
          <p className="text-muted fw-medium mb-0">Live Streaming</p>
          
        </div>
        <div className="avatar-sm rounded-circle bg-danger align-self-center mini-stat-icon">
          <span className="avatar-title rounded-circle bg-danger">
            <i className="bx bx-broadcast font-size-24"></i>
          </span>
        </div>
      </div>
    </CardBody>
  </Card>
);

const MetodeBelajarCard = () => (
  <Card className="mini-stats-wid shadow-sm border-0" style={{ borderRadius: '12px' }}>
    <CardBody>
      <div className="d-flex">
        <div className="flex-grow-1">
          <p className="text-muted fw-medium mb-0">Metode Belajar</p>
          <h4 className="mb-0 mt-2">6</h4>
        </div>
        <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
          <span className="avatar-title rounded-circle bg-primary">
            <i className="bx bx-bulb font-size-24"></i>
          </span>
        </div>
      </div>
    </CardBody>
  </Card>
);

// Komponen BankSoalCard yang menerima total soal sebagai prop
const BankSoalCard = ({ totalSoal }) => {
  return (
    <Card className="mini-stats-wid shadow-sm border-0" style={{ borderRadius: '12px' }}>
      <CardBody>
        <div className="d-flex">
          <div className="flex-grow-1">
            <p className="text-muted fw-medium mb-0">Bank Soal</p>
            <h4 className="mb-0 mt-2">{totalSoal}</h4>
          </div>
          <div className="avatar-sm rounded-circle bg-success align-self-center mini-stat-icon">
            <span className="avatar-title rounded-circle bg-success">
              <i className="bx bx-book-open font-size-24"></i>
            </span>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

// PropTypes untuk BankSoalCard
BankSoalCard.propTypes = {
    totalSoal: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.element
    ]),
};


const TotalUsersCard = ({ totalPengguna }) => {
  return (
    <Card className="mini-stats-wid shadow-sm border-0" style={{ borderRadius: '12px' }}>
      <CardBody>
        <div className="d-flex">
          <div className="flex-grow-1">
            <p className="text-muted fw-medium mb-0">Total Pengguna</p>
            <h4 className="mb-0 mt-2">{totalPengguna}</h4>
          </div>
          <div className="avatar-sm rounded-circle bg-info align-self-center mini-stat-icon">
            <span className="avatar-title rounded-circle bg-info">
              <i className="bx bx-user-plus font-size-24"></i>
            </span>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

// PropTypes untuk TotalUsersCard
TotalUsersCard.propTypes = {
    totalPengguna: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.element
    ]),
};

// --- Komponen Konsultasi Belajar (Tidak Berubah) ---
const KonsultasiBelajar = () => (
  <Card className="text-white bg-success shadow-sm border-0 h-100" style={{ minHeight: '250px', borderRadius: '12px', overflow: 'hidden', position: 'relative' }}>
    <CardBody className="p-4 d-flex flex-column justify-content-between">
      <div>
        <h4 className="card-title text-white mb-2">Konsultasi Belajar</h4>
        <p className="font-size-14 mb-3">
          Yuk konsultasikan kebutuhan belajar kamu di sini, belajar lebih efisien dan lulus jadi ASN lebih mudah.
        </p>
      </div>
      <Button color="warning" className="btn-rounded w-auto mt-3">
        <i className="bx bx-chat me-2"></i> Konsultasi Sekarang
      </Button>
      {/* Gambar placeholder, ganti dengan URL gambar Anda sendiri */}
      <img src="https://via.placeholder.com/150x150/66BB6A/FFFFFF?text=Konsultasi" alt="Konsultasi Belajar"
           style={{ position: 'absolute', bottom: '-20px', right: '-20px', maxWidth: '40%', height: 'auto', opacity: 0.8, filter: 'drop-shadow(0 0 5px rgba(0,0,0,0.2))' }} />
    </CardBody>
  </Card>
);

// --- Komponen Channel Belajar (Tidak Berubah) ---
const ChannelBelajar = () => (
  <Card className="text-white bg-primary shadow-sm border-0 h-100" style={{ minHeight: '250px', borderRadius: '12px', overflow: 'hidden', position: 'relative' }}>
    <CardBody className="p-4 d-flex flex-column justify-content-between">
      <div>
        <h4 className="card-title text-white mb-2">Channel Belajar</h4>
        <p className="font-size-14 mb-3">
          Siap jadi ASN? Yuk, gabung ke channel belajar ASN Institute di Whatsapp! Pecahkan soal-soal seru ala ujian asli bareng kita. Lolos ASN? Gampang!
      </p>
      </div>
      <Button color="light" className="btn-rounded w-auto mt-3">
        <i className="bx bxl-whatsapp me-2"></i> Channel CPNS
      </Button>
      {/* Gambar placeholder, ganti dengan URL gambar Anda sendiri */}
      <img src="https://via.placeholder.com/150x150/42A5F5/FFFFFF?text=ASN" alt="Channel Belajar"
           style={{ position: 'absolute', bottom: '-20px', right: '-20px', maxWidth: '40%', height: 'auto', opacity: 0.8, filter: 'drop-shadow(0 0 5px rgba(0,0,0,0.2))' }} />
    </CardBody>
  </Card>
);

// --- Komponen Gabung Grup Belajar + Ikuti Kami (Digabungkan dan Dipercantik) ---
const GabungGrupDanSosmed = () => (
  <Card className="shadow-sm border-0 h-100" style={{ borderRadius: '12px' }}>
    <CardBody>
      {/* Bagian Gabung Grup Belajar */}
      <h4 className="card-title mb-4">Gabung Grup Belajar</h4>
      <div className="d-grid gap-2 mb-5 pb-3 border-bottom"> {/* Menambahkan border-bottom untuk pemisah visual */}
        <Button color="light" className="mb-2 text-start" style={{ borderRadius: '8px', padding: '12px 15px' }}>
          <i className="bx bxl-telegram me-2 font-size-18"></i> Telegram (Gratis)
        </Button>
        <Button color="light" className="mb-2 text-start" style={{ borderRadius: '8px', padding: '12px 15px' }}>
          <i className="bx bxl-whatsapp me-2 font-size-18"></i> Whatsapp (Premium)
        </Button>

      </div>

      {/* Bagian Ikuti Kami (Sosial Media) yang Dipercantik */}
      <h4 className="card-title mt-4 mb-3">Ikuti Kami</h4>
      <div className="d-flex justify-content-center gap-3"> {/* Mengubah justify-content-start menjadi center */}
        {/* Ikon sosial media dengan styling baru */}
        {[
          { icon: "bxl-tiktok", color: "bg-dark" }, // TikTok
          { icon: "bxl-facebook", color: "bg-primary" }, // Facebook
          { icon: "bxl-instagram", color: "bg-danger" }, // Instagram (gunakan danger untuk representasi warna mirip gradien)
          { icon: "bxl-linkedin", color: "bg-info" }, // LinkedIn
          { icon: "bxl-youtube", color: "bg-danger" }, // YouTube
        ].map((socmed, index) => (
          <Link
            key={index}
            to="#"
            className={`d-flex align-items-center justify-content-center text-white ${socmed.color}`}
            style={{
              width: '45px',
              height: '45px',
              borderRadius: '50%', // Bentuk lingkaran
              fontSize: '24px',
              transition: 'transform 0.2s ease-in-out', // Efek hover
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <i className={`bx ${socmed.icon}`}></i>
          </Link>
        ))}
      </div>
    </CardBody>
  </Card>
);


const Dashboard = props => {
  document.title = "Beranda";

  const [totalSoalCount, setTotalSoalCount] = useState(null);
  const [totalUserCount, setTotalUserCount] = useState(null);

  useEffect(() => {
    const fetchCounts = async () => {
      // Fetch total soal
      try {
        const response = await totalSoal();
        if (response && response.data) {
          setTotalSoalCount(response.data.toLocaleString('id-ID'));
        } else {
          setTotalSoalCount("N/A");
          toast.error("Gagal mendapatkan total soal.");
        }
      } catch (error) {
        console.error("Error fetching total soal:", error);
        setTotalSoalCount("Error");
        toast.error("Gagal mendapatkan total soal.");
      }

      // Fetch total users
      try {
        const response = await totalUser();
        if (response && response.data) {
          setTotalUserCount(response.data.toLocaleString('id-ID'));
        } else {
          setTotalUserCount("N/A");
          toast.error("Gagal mendapatkan total pengguna.");
        }
      } catch (error) {
        console.error("Error fetching total users:", error);
        setTotalUserCount("Error");
        toast.error("Gagal mendapatkan total pengguna.");
      }
    };

    fetchCounts();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="pb-5">
          <Breadcrumbs title={props.t("Dashboards")} breadcrumbItem={props.t("Beranda")} />

          <Row>
            <Col md="3">
              <LiveStreamingCard />
            </Col>
            <Col md="3">
              <MetodeBelajarCard />
            </Col>
            <Col md="3">
              <BankSoalCard totalSoal={totalSoalCount === null ? <Spinners /> : totalSoalCount} />
            </Col>
            <Col md="3">
              <TotalUsersCard totalPengguna={totalUserCount === null ? <Spinners /> : totalUserCount} />
            </Col>
          </Row>

          <Row className="mt-4">
            <Col xl="8">
              <Row className="mb-4">
                <Col xl="12">
                  <ImageSlider />
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <KonsultasiBelajar />
                </Col>
                <Col md="6">
                  <ChannelBelajar />
                </Col>
              </Row>
            </Col>

            <Col xl="4">
              <GabungGrupDanSosmed />
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Dashboard);
